import React from "react";
import Base from "../core/Base";
import HeaderTitle from "../components/HeaderTitle";

const FeeStructure = () => {
    return (
        <Base>
            <HeaderTitle title='Fee Structure'/>
            <section className="contact-area ptb-100">
                <h2 className='text-center mb-5'>Fee Structure</h2>
                <div className='container'>
                    <div className='table table-rasponsive'>
                        <table className='table table-bordered text-center fee-table'>
                            <thead>
                            <tr className="thead-dark">
                                <th>Hours</th>
                                <th>Shift Time</th>
                                <th>Price</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td colSpan="3" className="blank-row"></td>
                            </tr>
                            <tr className="fee-row">
                                <td>4 Hours</td>
                                <td className="p-0">
                                    <table className="table table-borderless">
                                        <tr>
                                            <td>8AM TO 12PM</td>
                                        </tr>
                                        <tr>
                                            <td>10AM TO 2PM</td>
                                        </tr>
                                    </table>
                                </td>
                                <td><i className='icofont-rupee'></i>400</td>
                            </tr>

                            <tr>
                                <td colSpan="3" className="blank-row"></td>
                            </tr>

                            <tr className="fee-row">
                                <td><span>6 Hours</span></td>
                                <td className="p-0">
                                    <table className="table table-borderless">
                                        <tr>
                                            <td>8AM TO 2PM</td>
                                        </tr>
                                        <tr>
                                            <td>10AM TO 4PM</td>
                                        </tr>
                                        <tr>
                                            <td>12AM TO 6PM</td>
                                        </tr>
                                        <tr>
                                            <td>2PM TO 8PM</td>
                                        </tr>
                                        <tr>
                                            <td>4PM TO 10PM</td>
                                        </tr>
                                    </table>
                                </td>
                                <td><i className='icofont-rupee'></i>600</td>
                            </tr>


                            <tr>
                                <td colSpan="3" className="blank-row"></td>
                            </tr>

                            <tr className="fee-row">
                                <td>8 Hours</td>
                                <td className="p-0">
                                    <table className="table table-borderless">
                                        <tr>
                                            <td>8AM TO 4PM</td>
                                        </tr>
                                        <tr>
                                            <td>10AM TO 4PM</td>
                                        </tr>
                                        <tr>
                                            <td>12AM TO 8PM</td>
                                        </tr>
                                        <tr>
                                            <td>2PM TO 10PM</td>
                                        </tr>
                                    </table>
                                </td>
                                <td><i className='icofont-rupee'></i>700</td>
                            </tr>


                            <tr>
                                <td colSpan="3" className="blank-row"></td>
                            </tr>

                            <tr className="fee-row">
                                <td>12 Hours</td>
                                <td className="p-0">
                                    <table className="table table-borderless">
                                        <tr>
                                            <td>8AM TO 8PM</td>
                                        </tr>
                                        <tr>
                                            <td>9AM TO 9PM</td>
                                        </tr>
                                        <tr>
                                            <td>10AM TO 10PM</td>
                                        </tr>
                                    </table>
                                </td>
                                <td><i className='icofont-rupee'></i>1000</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="container mt-5">
                    <div className="row">
                        <div className="col-lg-4 col-md-12">
                            <div className="contact-box">
                                <div className="icon">
                                    <i className="icofont-phone"></i>
                                </div>

                                <div className="content">
                                    <h4>Mobile Number</h4>
                                    <p></p>
                                    <p><a href="tel:9359587399">+91 9359587399</a></p>
                                    <p><a href="tel:8077187959">+91 8077187959</a></p>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-4 col-md-12">
                            <div className="contact-box">
                                <div className="icon">
                                    <i className="icofont-envelope"></i>
                                </div>

                                <div className="content">
                                    <h4>E-mail Address</h4>
                                    <p><a href="mailto:info@Sarkarizone.com">info@Sarkarizone.com </a></p>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-4 col-md-12">
                            <div className="contact-box">
                                <div className="icon">
                                    <i className="icofont-google-map"></i>
                                </div>

                                <div className="content">
                                    <h4>Address</h4>
                                    <p>8/195 Engineer's Colony, Opp. Omaxe Mall, Bye Pass
                                        Road,<span>Agra - 282005</span></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </Base>
    );
};

export default FeeStructure;
